import { Box, BoxProps } from "@chakra-ui/react";
import { FiEye } from "react-icons/fi";

export const EyeIcon = (props: BoxProps) => {
  return <Box as={FiEye} height="20px" width="20px" {...props} />;
};
